export class Menu {
  title: string;
  path: string;
  icon: string;
  subMenu: Menu[] | null;
  locais?: number[] | null;

  constructor(
    title: string,
    path: string,
    icon: string,
    subMenu: Menu[] | null,
    locais?: number[] | null,
  ) {
    this.title = title;
    this.path = path;
    this.icon = icon;
    this.subMenu = subMenu;
    this.locais = locais;
  }
}
